import { createApp } from 'vue';
import BuilderApp from './components/BuilderApp.vue';
import '../../css/builder.css';

// Create Vue app
const app = createApp(BuilderApp);

// Mount app
app.mount('#ui-builder-app');

